import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import store, { setIsLoading } from "../store";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import NProgressWrapper from "@components/Common/NProgressWrapper";

type ConfirmationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsValidateClicked: Function;
    msg: string;
    isArchived?: boolean;
};

export function ConfirmationMessage({
    setIsModalOpened,
    isModalOpened,
    setIsValidateClicked,
    msg,
    isArchived,
}: ConfirmationMessageType) {
    const { t } = useTranslation();
    const { isLoading } = useSnapshot(store);

    return (
        <React.Fragment>
            <StyledModal toggle={true} isOpen={isModalOpened!} centered>
                <ModalHeader
                    className="text-capitalize"
                    toggle={() => {
                        if (isLoading === false) {
                            setIsModalOpened(!isModalOpened);
                        }
                    }}
                >
                    <StyledH2>{capitalize(t("Alert"))}</StyledH2>
                </ModalHeader>
                <ModalBody>
                    <StyledLabel
                        className="pl-3 m-0"
                        style={{ whiteSpace: "pre-line" }}
                    >
                        {msg}
                    </StyledLabel>
                </ModalBody>
                <ModalFooter className="border-top-0 ">
                    {!isArchived && (
                        <CustomSecondaryColorButton
                            className={`${classnames({
                                "not-allowed-icon__clz": isLoading,
                            })}`}
                            outline
                            variant="light"
                            onClick={() => {
                                setIsModalOpened(!isModalOpened);
                            }}
                            rounded
                        >
                            {t("Cancel")}
                        </CustomSecondaryColorButton>
                    )}
                    <CustomMainColorButton
                        className={`${classnames("mr-2", {
                            "not-allowed-icon__clz": isLoading,
                        })}`}
                        rounded
                        variant="primary"
                        onClick={() => {
                            setIsLoading(true);
                            !isArchived
                                ? setIsValidateClicked(true)
                                : setIsModalOpened(!isModalOpened);
                        }}
                    >
                        {!isArchived ? t("Validate") : t("Ok")}
                    </CustomMainColorButton>
                </ModalFooter>
            </StyledModal>
            <NProgressWrapper isLoading={isLoading} />{" "}
        </React.Fragment>
    );
}
